import X from '../x.js';
import '../x-item/index.js';
import '../x-color/index.js';

import commonCSS from '../../../css/common.js';

class XAdd extends X {
  static get properties() {
    return {
      _id: {
        type: String
      },
      name: {
        type: String
      },
      when: {
        type: String
      },
      start: {
        type: Number
      },
      color: {
        type: String
      }
    };
  }

  constructor() {
    super();

    this.reset();
  }

  reset() {
    this._id = null;
    this.name = null;
    this.when = null;
    this.start = null;
    this.color = null;
  }

  clear() {
    this.reset();
    this.$._id.value = '';
    this.$.name.value = '';
    this.$.when.value = '';
    this.$.startDate.value = '';
    this.$.startTime.value = '';
  }

  render(target) {
    target.innerHTML = `
      <style>
        ${commonCSS}

        :host {
          display: block;
          padding: 2rem;
          color: var(--x-color-text);
        }

        form {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
        }

        form input,
        form x-color {
          margin-bottom: 1rem;
        }

        :host(:not([_id])) form#delete {
          display: none;
        }
      </style>

    <form id="add">
      <input id="_id" name="_id" type="hidden">
      <label>
        Name
        <input id="name" name="name" type="text" placeholder="Ada's Birthday">
      </label>
      <label>
        Frequency
        <input id="when" name="when" type="text" placeholder="e.g. 10s, 3h, 4d, 1y">
      </label>
      <label>
        Start date (default: now)
        <input id="startDate" name="start-date" type="date">
      </label>
      <label>
        Start time (default: now)
        <input id="startTime" name="start-time" type="time">
      </label>
      <x-color id="color"></x-color>
      <button id="button">Add event</button>
    </form>

    <form id="delete">
      <input name="_id" type="hidden">
      <button>Delete</button>
    </form>
    `;
  }

  setup() {
    this.$.color.options = ['#ee7752', '#e73c7e', '#23a6d5', '#23d5ab'];
    this.on(this.$.add, 'submit', this.onAddFormSubmit);
    this.on(this.$.delete, 'submit', this.onDeleteFormSubmit);
  }

  update(target, triggers) {
    for (let propName in triggers) {
      if (this.$[propName]) {
        this.$[propName].value = this[propName];
      }
    }

    if ('start' in triggers && this.start) {
      const start = new Date(this.start);
      let month = start.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let date = start.getDate();
      if (date < 10) {
        date = `0${date}`;
      }
      let hours = start.getHours();
      if (hours < 10) {
        hours = `0${hours}`;
      }
      let minutes = start.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      this.$.startDate.value = `${start.getFullYear()}-${month}-${date}`;
      this.$.startTime.value = `${hours}:${minutes}`;
    }

    if ('color' in triggers) {
      this.$.color.value = this.color;
    }

    if ('_id' in triggers) {
      if (this._id) {
        this.$.button.textContent = 'Save event';
      } else {
        this.$.button.textContent = 'Add event';
      }
    }
  }

  onAddFormSubmit(event) {
    event.preventDefault();

    let _id = this.$._id.value.trim();
    let start = this.start;

    const name = this.$.name.value.trim();
    const when = this.$.when.value.trim();
    const startDate = this.$.startDate.value;
    const startTime = this.$.startTime.value;
    const color = this.$.color.value;

    if (name && when) {
      if (!_id) {
        const now = Date.now();
        _id = `item-${now}`;
        start = now;
      }

      if (startDate) {
        let date = startDate;
        if (startTime) {
          date = `${startDate}T${startTime}`;
        }

        start = new Date(date).valueOf();
      }

      this.emit('x-item-add', {
        _id,
        name,
        when,
        startDate,
        startTime,
        start,
        color
      });
    }
  }

  onDeleteFormSubmit(event) {
    event.preventDefault();

    let _id = this.$._id.value.trim();

    if (_id) {
      this.emit('x-item-delete', {
        _id
      });
    }
  }
}

customElements.define('x-add', XAdd);
